import React from 'react';

const ConstellationBackground: React.FC = () => {
  return (
    <div 
      className="fixed inset-0 w-full h-full pointer-events-none z-0"
      style={{ 
        backgroundColor: '#1a1a1a',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh'
      }}
    />
  );
};

export default ConstellationBackground;
